import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../features/auth/authSlice";

const SessionExpiredModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessionExpired = useSelector((state) => state.auth.sessionExpired);

  if (!sessionExpired) return null;

  const handleLoginAgain = () => {
    dispatch(logout()); // clears token/user/role + resets sessionExpired
    navigate("/", { replace: true });
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0, 0, 0, 0.5)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="bg-white rounded shadow p-4 text-center"
        style={{ maxWidth: "400px", width: "90%" }}
        role="dialog"
        aria-modal="true"
      >
        <h5 className="mb-3 fw-bold">Session Expired</h5>
        <p className="text-muted mb-4">
          Your session has expired. Please log in again to continue.
        </p>
        <button
          type="button"
          className="btn btn-primary w-100"
          onClick={handleLoginAgain}
        >
          Login Again
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
